/**
 * @generated SignedSource<<30e43f36d796dd467267cc4ffb99e860>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CountryCode = "ABW" | "AFG" | "AGO" | "AIA" | "ALA" | "ALB" | "AND" | "ARE" | "ARG" | "ARM" | "ASM" | "ATA" | "ATF" | "ATG" | "AUS" | "AUT" | "AZE" | "BDI" | "BEL" | "BEN" | "BES" | "BFA" | "BGD" | "BGR" | "BHR" | "BHS" | "BIH" | "BLM" | "BLR" | "BLZ" | "BMU" | "BOL" | "BRA" | "BRB" | "BRN" | "BTN" | "BVT" | "BWA" | "CAF" | "CAN" | "CCK" | "CHE" | "CHL" | "CHN" | "CIV" | "CMR" | "COD" | "COG" | "COK" | "COL" | "COM" | "CPV" | "CRI" | "CUB" | "CUW" | "CXR" | "CYM" | "CYP" | "CZE" | "DEU" | "DJI" | "DMA" | "DNK" | "DOM" | "DZA" | "ECU" | "EGY" | "ERI" | "ESH" | "ESP" | "EST" | "ETH" | "FIN" | "FJI" | "FLK" | "FRA" | "FRO" | "FSM" | "GAB" | "GBR" | "GEO" | "GGY" | "GHA" | "GIB" | "GIN" | "GLP" | "GMB" | "GNB" | "GNQ" | "GRC" | "GRD" | "GRL" | "GTM" | "GUF" | "GUM" | "GUY" | "HKG" | "HMD" | "HND" | "HRV" | "HTI" | "HUN" | "IDN" | "IMN" | "IND" | "IOT" | "IRL" | "IRN" | "IRQ" | "ISL" | "ISR" | "ITA" | "JAM" | "JEY" | "JOR" | "JPN" | "KAZ" | "KEN" | "KGZ" | "KHM" | "KIR" | "KNA" | "KOR" | "KWT" | "LAO" | "LBN" | "LBR" | "LBY" | "LCA" | "LIE" | "LKA" | "LSO" | "LTU" | "LUX" | "LVA" | "MAC" | "MAF" | "MAR" | "MCO" | "MDA" | "MDG" | "MDV" | "MEX" | "MHL" | "MKD" | "MLI" | "MLT" | "MMR" | "MNE" | "MNG" | "MNP" | "MOZ" | "MRT" | "MSR" | "MTQ" | "MUS" | "MWI" | "MYS" | "MYT" | "NAM" | "NCL" | "NER" | "NFK" | "NGA" | "NIC" | "NIU" | "NLD" | "NOR" | "NPL" | "NRU" | "NZL" | "OMN" | "PAK" | "PAN" | "PCN" | "PER" | "PHL" | "PLW" | "PNG" | "POL" | "PRI" | "PRK" | "PRT" | "PRY" | "PSE" | "PYF" | "QAT" | "REU" | "ROU" | "RUS" | "RWA" | "SAU" | "SDN" | "SEN" | "SGP" | "SGS" | "SHN" | "SJM" | "SLB" | "SLE" | "SLV" | "SMR" | "SOM" | "SPM" | "SRB" | "SSD" | "STP" | "SUR" | "SVK" | "SVN" | "SWE" | "SWZ" | "SXM" | "SYC" | "SYR" | "TCA" | "TCD" | "TGO" | "THA" | "TJK" | "TKL" | "TKM" | "TLS" | "TON" | "TTO" | "TUN" | "TUR" | "TUV" | "TWN" | "TZA" | "UGA" | "UKR" | "UMI" | "URY" | "USA" | "UZB" | "VAT" | "VCT" | "VEN" | "VGB" | "VIR" | "VNM" | "VUT" | "WLF" | "WSM" | "YEM" | "ZAF" | "ZMB" | "ZWE";
export type SimulationAddressInput = {
  addressId?: string | null;
  addressType?: string | null;
  countryCode?: CountryCode | null;
  geoCoordinates?: ReadonlyArray<number> | null;
  postalCode?: string | null;
};
export type PaymentMethodWhereInput = {
  id?: PaymentMethodWhereIdOperatorInput | null;
};
export type PaymentMethodWhereIdOperatorInput = {
  in: ReadonlyArray<string>;
};
export type NewProductPageQuery$variables = {
  id: string;
  addresses: ReadonlyArray<SimulationAddressInput>;
  paymentMethod?: PaymentMethodWhereInput | null;
};
export type NewProductPageQuery$data = {
  readonly product: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProductSkuRef_Product" | "ProductSkuImage_Product" | "ProductSkuPrice_Product" | "ProductSkuPromotions_Product" | "ProductSkuHighlightedPromotion_Product" | "ProductSkuSelection_Product" | "ProductSkuAvailability_Product" | "ProductSkuPaymentData_Product" | "ProductDetailsDrawer_Product">;
  } | null;
};
export type NewProductPageQuery = {
  variables: NewProductPageQuery$variables;
  response: NewProductPageQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addresses"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paymentMethod"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "kind": "Variable",
  "name": "addresses",
  "variableName": "addresses"
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "netPrice",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "values",
    "storageKey": null
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "total",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewProductPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductSkuRef_Product"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductSkuImage_Product"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductSkuPrice_Product"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductSkuPromotions_Product"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductSkuHighlightedPromotion_Product"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductSkuSelection_Product"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductSkuAvailability_Product"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductSkuPaymentData_Product"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductDetailsDrawer_Product"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewProductPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "product",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductSkuConnection",
            "kind": "LinkedField",
            "name": "skus",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductSkuEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductSku",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "refId",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductSkuImage",
                        "kind": "LinkedField",
                        "name": "defaultImage",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": 1000
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": "url(size:1000)"
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v7/*: any*/),
                        "concreteType": "ProductSkuOfferConnection",
                        "kind": "LinkedField",
                        "name": "offers",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductSkuOfferEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductSkuOffer",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Seller",
                                    "kind": "LinkedField",
                                    "name": "seller",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "deliveryChannel",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Money",
                                    "kind": "LinkedField",
                                    "name": "listPrice",
                                    "plural": false,
                                    "selections": (v9/*: any*/),
                                    "storageKey": null
                                  },
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "priority",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductSkuOfferDeliveryAvailabilityConnection",
                                    "kind": "LinkedField",
                                    "name": "deliveryAvailabilities",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductSkuOfferDeliveryAvailabilityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductSkuOfferDeliveryAvailability",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v4/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "shippingEstimate",
                                                "storageKey": null
                                              },
                                              (v10/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "pickupDistance",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "stock",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v7/*: any*/),
                        "concreteType": "PromotionConnection",
                        "kind": "LinkedField",
                        "name": "promotions",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PromotionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "highlight",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductSkuVariationConnection",
                        "kind": "LinkedField",
                        "name": "variations",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductSkuVariationEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductSkuVariation",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v11/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          (v6/*: any*/),
                          {
                            "kind": "Variable",
                            "name": "paymentMethod",
                            "variableName": "paymentMethod"
                          }
                        ],
                        "concreteType": "PaymentOptionConnection",
                        "kind": "LinkedField",
                        "name": "paymentOptions",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PaymentOptionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PaymentOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PaymentOptionInstallmentConnection",
                                    "kind": "LinkedField",
                                    "name": "installments",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PaymentOptionInstallmentEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "PaymentOptionInstallment",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Money",
                                                "kind": "LinkedField",
                                                "name": "value",
                                                "plural": false,
                                                "selections": (v9/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "interestRate",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "quantity",
                                                "storageKey": null
                                              },
                                              (v13/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v12/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PaymentMethod",
                                    "kind": "LinkedField",
                                    "name": "paymentMethod",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v5/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "groupName",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v13/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductSkuSpecificationConnection",
            "kind": "LinkedField",
            "name": "productSkuSpecifications",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductSkuSpecificationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductSkuSpecification",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v11/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8f15469f163d8a229712e47b04e1be72",
    "id": null,
    "metadata": {},
    "name": "NewProductPageQuery",
    "operationKind": "query",
    "text": "query NewProductPageQuery(\n  $id: ID!\n  $addresses: [SimulationAddressInput!]!\n  $paymentMethod: PaymentMethodWhereInput\n) {\n  product(id: $id) {\n    name\n    ...ProductSkuRef_Product\n    ...ProductSkuImage_Product\n    ...ProductSkuPrice_Product\n    ...ProductSkuPromotions_Product\n    ...ProductSkuHighlightedPromotion_Product\n    ...ProductSkuSelection_Product\n    ...ProductSkuAvailability_Product\n    ...ProductSkuPaymentData_Product\n    ...ProductDetailsDrawer_Product\n    id\n  }\n}\n\nfragment BestPaymentDrawer_PaymentOption on PaymentOption {\n  paymentMethod {\n    name\n    id\n  }\n  ...PaymentMethodInfoContent_PaymentOption\n}\n\nfragment BestPaymentMethod_PaymentOptionConnection on PaymentOptionConnection {\n  edges {\n    node {\n      installments {\n        edges {\n          node {\n            value {\n              amount\n            }\n          }\n        }\n      }\n      ...BestPaymentDrawer_PaymentOption\n      ...utils_PaymentOption\n    }\n  }\n}\n\nfragment PaymentMethodInfoContent_PaymentOption on PaymentOption {\n  total {\n    amount\n  }\n  installments {\n    edges {\n      node {\n        interestRate\n        quantity\n        total {\n          amount\n        }\n        value {\n          amount\n        }\n      }\n    }\n  }\n  ...utils_PaymentOption\n}\n\nfragment PaymentMethodInfoStep_PaymentOptionConnection on PaymentOptionConnection {\n  edges {\n    node {\n      paymentMethod {\n        id\n        name\n      }\n      ...PaymentMethodInfoContent_PaymentOption\n    }\n  }\n}\n\nfragment PaymentsMethodsListContentBestInstallment_PaymentOption on PaymentOption {\n  total {\n    amount\n  }\n  ...utils_PaymentOption\n}\n\nfragment PaymentsMethodsListContentStep_PaymentOptionConnection on PaymentOptionConnection {\n  edges {\n    node {\n      paymentMethod {\n        id\n        groupName\n        name\n      }\n      installments {\n        edges {\n          __typename\n        }\n      }\n      ...PaymentsMethodsListContentBestInstallment_PaymentOption\n    }\n  }\n}\n\nfragment PaymentsMethodsListDrawer_PaymentOptionConnection on PaymentOptionConnection {\n  ...PaymentsMethodsListContentStep_PaymentOptionConnection\n  ...PaymentMethodInfoStep_PaymentOptionConnection\n}\n\nfragment ProductDetailsDrawer_Product on Product {\n  description\n}\n\nfragment ProductSkuAvailabilityDelivery_ProductSkuOfferConnection on ProductSkuOfferConnection {\n  edges {\n    node {\n      deliveryChannel\n      netPrice {\n        amount\n      }\n      deliveryAvailabilities {\n        edges {\n          node {\n            name\n            shippingEstimate\n            netPrice {\n              amount\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment ProductSkuAvailabilityPickup_ProductSkuOfferConnection on ProductSkuOfferConnection {\n  edges {\n    node {\n      deliveryChannel\n      netPrice {\n        amount\n      }\n      deliveryAvailabilities {\n        edges {\n          node {\n            name\n            pickupDistance\n            shippingEstimate\n            netPrice {\n              amount\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment ProductSkuAvailabilityTakeAway_ProductSkuOfferConnection on ProductSkuOfferConnection {\n  edges {\n    node {\n      deliveryChannel\n      stock\n      id\n    }\n  }\n}\n\nfragment ProductSkuAvailability_Product on Product {\n  skus {\n    edges {\n      node {\n        id\n        offers(addresses: $addresses) {\n          ...ProductSkuAvailabilityDelivery_ProductSkuOfferConnection\n          ...ProductSkuAvailabilityPickup_ProductSkuOfferConnection\n          ...ProductSkuAvailabilityTakeAway_ProductSkuOfferConnection\n        }\n      }\n    }\n  }\n}\n\nfragment ProductSkuHighlightedPromotion_Product on Product {\n  skus {\n    edges {\n      node {\n        id\n        promotions(addresses: $addresses) {\n          edges {\n            node {\n              id\n              name\n              highlight\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ProductSkuImage_Product on Product {\n  skus {\n    edges {\n      node {\n        id\n        name\n        defaultImage {\n          url(size: 1000)\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ProductSkuOtherOffers_Product on Product {\n  skus {\n    edges {\n      node {\n        id\n        offers(addresses: $addresses) {\n          ...productSkuOfferConnection_ProductSkuOfferConnection\n        }\n      }\n    }\n  }\n}\n\nfragment ProductSkuPaymentData_Product on Product {\n  skus {\n    edges {\n      node {\n        id\n        paymentOptions(addresses: $addresses, paymentMethod: $paymentMethod) {\n          edges {\n            node {\n              __typename\n            }\n          }\n          ...BestPaymentMethod_PaymentOptionConnection\n          ...PaymentsMethodsListDrawer_PaymentOptionConnection\n        }\n      }\n    }\n  }\n}\n\nfragment ProductSkuPrice_Product on Product {\n  skus {\n    edges {\n      node {\n        id\n        offers(addresses: $addresses) {\n          ...productSkuOfferConnection_ProductSkuOfferConnection\n        }\n      }\n    }\n  }\n}\n\nfragment ProductSkuPromotions_Product on Product {\n  skus {\n    edges {\n      node {\n        id\n        promotions(addresses: $addresses) {\n          edges {\n            node {\n              id\n              name\n              highlight\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ProductSkuRef_Product on Product {\n  skus {\n    edges {\n      node {\n        id\n        refId\n      }\n    }\n  }\n}\n\nfragment ProductSkuSelection_Product on Product {\n  name\n  productSkuSpecifications {\n    edges {\n      node {\n        name\n        values\n      }\n    }\n  }\n  skus {\n    edges {\n      node {\n        _id\n        id\n        name\n        variations {\n          edges {\n            node {\n              name\n              values\n            }\n          }\n        }\n      }\n    }\n  }\n  ...ProductSkuOtherOffers_Product\n}\n\nfragment productSkuOfferConnection_ProductSkuOfferConnection on ProductSkuOfferConnection {\n  edges {\n    node {\n      seller {\n        _id\n        id\n      }\n      deliveryChannel\n      listPrice {\n        amount\n      }\n      netPrice {\n        amount\n      }\n      priority\n      id\n    }\n  }\n}\n\nfragment utils_PaymentOption on PaymentOption {\n  total {\n    amount\n  }\n  installments {\n    edges {\n      node {\n        interestRate\n        total {\n          amount\n        }\n        value {\n          amount\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "428cfc2405bb44c84b59555c2210365f";

export default node;
